
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ShipFrom, ShipTo } from '@/features/shipment/types';

@Component
export default class MobileCollapsedAddress extends Vue {
  @Prop({ required: true }) data!: ShipFrom | ShipTo;

  @Prop({ default: 'from' }) location!: 'from' | 'to';

  @Prop({ default: true }) showImportButton!: boolean;

  get locationTitle(): string {
    return this.$t(`shipment.${this.location === 'from' ? 'shipFrom' : 'shipTo'}`) as string;
  }

  get addressSummary(): string {
    const parts = [
      this.data.addr1,
      this.data.addr2,
      this.data.addr3,
    ].filter(Boolean);

    const cityPostal = [this.data.postalCode, this.data.city]
      .filter(Boolean).join(' ');

    if (cityPostal) parts.push(cityPostal);

    return parts.join(', ');
  }
}
